import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { CustomersArr } from "./data";
import { ReferencesLogos } from "../ReferencesLogos";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

interface CustomerImage {
  customer_image: string;
}

export const ScientificallyBackedSection = () => {
  const sections = useSectionsData();
  const scientificallyBackedSection = sections?.pp_v7_scientifically_backed;
  const brandName = getBrandName();
  const customerImages: CustomerImage[] =
    scientificallyBackedSection?.customers_images?.length > 0
      ? scientificallyBackedSection.customers_images
      : CustomersArr.map((item) => ({ customer_image: item.src }));

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.scientificallyBackedSection}>
        <h3
          className={s.scientificallyBackedSection__title}
          dangerouslySetInnerHTML={{
            __html: scientificallyBackedSection.tr_heading,
          }}
        />
        <div className={s.scientificallyBackedSection__logos}>
          <ReferencesLogos />
        </div>
        <div className={s.scientificallyBackedSection__customersImg}>
          {customerImages.map((customer, index) => (
            <div key={index}>
              <img
                src={glideImage(customer.customer_image, { w: 182, h: 262 })}
                alt={brandName}
                width={182}
                height={262}
              />
            </div>
          ))}
        </div>
      </div>
    </PageWrapper>
  );
};
